import LandingPage from "../../components/layout/landing-page/landing-page";
import Footer from "../../components/layout/footer/footer";
import Header from "../../components/layout/header/header";

function LandingPageWrapper() {
  return (
    <>
      <Header />
      <LandingPage />
      <Footer />
    </>
  );
}

export default LandingPageWrapper;
